var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_211_35062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 280.232L847.76 276.769V526.716L774.826 477.917L668.856 523.587L561.64 477.916L468.761 564.876L368.401 593.656L324.147 556.745L289.24 503.568L256.203 535.472L182.646 473.536L131.531 481.042L74.184 431.62L0 412.853V280.232Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.889 83.526L669.019 143.943L669.222 414.004C671.983 414.004 675.974 414.004 677.407 414.004C680.73 413.889 682.663 413.905 693.266 412.898C696.54 412.584 696.335 412.743 710.25 411.798C728.052 410.85 735.826 409.595 748.516 408.483L748.719 141.263L735.727 88.889C736.28 87.769 685.303 83.179 658.889 83.526Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.829 250.092C733.572 250.092 824.969 236.32 824.969 219.331C824.969 202.342 733.572 188.57 620.829 188.57C508.086 188.57 416.689 202.342 416.689 219.331C416.689 236.32 508.086 250.092 620.829 250.092Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.829 416.37C733.572 416.37 824.969 402.598 824.969 385.609C824.969 368.62 733.572 354.848 620.829 354.848C508.086 354.848 416.689 368.62 416.689 385.609C416.689 402.598 508.086 416.37 620.829 416.37Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M825.045 387.504C825.045 387.504 822.342 415.763 620.829 415.763C413.985 415.763 416.689 387.504 416.689 387.504V217.511C416.689 217.511 417.627 186.751 620.829 186.751C825.983 186.751 825.045 217.511 825.045 217.511V387.504Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.976 73.9941H571.347V85.8011H575.976V73.9941Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.629 77.4951V90.5151L511.044 89.9081V77.4951H507.629Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.629 80.9982L575.976 77.4962V73.3872L507.629 76.9762V80.9982Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.928 82.2122L520.164 87.9692L526.795 87.4442L507.8 76.8882L507.928 82.2122Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.104 78.7112L588.341 84.4682L594.972 83.9432L575.976 73.3872L576.104 78.7112Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.347 73.6304V77.1934",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.044 79.2981V76.8511",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.572 75.3912C574.585 75.8942 574.192 76.3102 573.689 76.3212C573.186 76.3322 572.766 75.9332 572.752 75.4302C572.737 74.9282 573.132 74.5112 573.634 74.5012C574.137 74.4902 574.556 74.8892 574.572 75.3912Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.531 145.135C655.512 145.61 641.291 146.239 624.716 145.923C418.044 141.98 415.793 113.586 415.793 113.586V390.112C415.793 390.112 415.793 420.099 626.252 420.099C642.213 420.099 649.02 420.099 669.632 419.004",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.531 145.135C655.512 145.61 641.291 146.239 624.716 145.923C418.044 141.98 415.793 113.586 415.793 113.586V390.112C415.793 390.112 415.793 420.099 626.252 420.099C642.213 420.099 649.02 420.099 669.632 419.004",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.767 85.9517V103.289H434.576V85.3457L431.767 85.9517Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.846 84.1328V95.9398H469.475V84.7398L464.846 84.1328Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.259 83.5259H445.63V100.255H450.259V83.5259Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.007 90.9419L429.038 87.0059L437.131 84.9609L446.031 84.1329L460.473 84.0049L473.707 85.3469L483.027 87.3889L490.337 90.0499L486.082 90.6799L483.857 90.0729L473.541 87.8479L460.693 86.4319L446.03 86.2549L437.333 86.8369L429.947 88.4549L427.215 91.0849L428.836 91.8709L429.949 92.5989L433.236 94.3209L436.422 95.8889L440.619 97.9619L442.794 98.5689L440.467 99.2259L439.405 98.7709L436.067 97.4569L433.084 95.7369L430.353 94.1189L428.735 93.0059L427.319 92.2229L427.007 90.9419Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.627 85.9389C467.638 86.2739 467.374 86.5519 467.039 86.5589C466.703 86.5659 466.424 86.2999 466.414 85.9649C466.404 85.6299 466.668 85.3529 467.003 85.3449C467.337 85.3379 467.617 85.6039 467.627 85.9389Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.551 85.2579C448.56 85.5509 448.33 85.7939 448.036 85.8009C447.743 85.8069 447.498 85.5739 447.49 85.2819C447.48 84.9889 447.711 84.7459 448.005 84.7389C448.298 84.7329 448.543 84.9649 448.551 85.2579Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.767 86.8021C433.775 87.0541 433.578 87.2611 433.325 87.2671C433.074 87.2721 432.863 87.0731 432.857 86.8221C432.849 86.5711 433.046 86.3631 433.298 86.3571C433.55 86.3511 433.76 86.5511 433.767 86.8021Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.828 90.9419V107.672L431.636 109.492V92.7629L428.828 90.9419Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.231 413.34C825.966 406.085 825.046 389.325 825.046 389.325V113.586C825.046 113.586 825.046 129.361 748.311 138.352",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.231 413.34C825.966 406.085 825.046 389.325 825.046 389.325V113.586C825.046 113.586 825.046 129.361 748.311 138.352",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.806 88.3462C739.746 106.912 744.526 122.736 748.72 139.772L734.806 88.3462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.806 88.3462C739.746 106.912 744.526 122.736 748.72 139.772",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.426 145.45C655.211 145.923 640.887 146.24 625.638 146.24C509.718 146.082 415.793 131.885 415.793 114.219C415.793 96.55 509.715 83.931 625.638 83.931C641.397 83.931 644.464 83.3 659.196 83.615",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.426 145.45C655.211 145.923 640.887 146.24 625.638 146.24C509.718 146.082 415.793 131.885 415.793 114.219C415.793 96.55 509.715 83.931 625.638 83.931C641.397 83.931 644.464 83.3 659.196 83.615",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.334 138.351H748.31V413.251H749.334V138.351Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.419 88.418C782.177 94.253 825.045 100.493 825.045 113.901C825.045 124.943 796.809 133.759 748.928 138.737",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.419 88.418C782.177 94.253 825.045 100.493 825.045 113.901C825.045 124.943 796.809 133.759 748.928 138.737",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5298 178.812C48.1098 178.812 24.2578 205.452 24.2578 238.311V255.666C24.2578 288.524 48.1098 315.165 77.5298 315.165H321.698C351.124 315.165 374.973 288.525 374.973 255.666V238.311C374.973 205.452 351.124 178.812 321.698 178.812H77.5298Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.573 303.4C115.573 303.4 115.573 304.463 116.619 311.025C117.546 316.839 122.17 315.09 122.17 315.09V334.615L115.573 345.775V303.4Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.683 294.262H94.207V345.775H115.683V294.262Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.475 351.842L274.877 338.277V314.543C274.877 314.543 279.501 316.669 280.428 309.601C281.475 301.623 281.475 300.331 281.475 300.331V351.842Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.841 300.331H281.365V351.844H302.841V300.331Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.5298 179.211C48.1098 179.211 24.2578 205.695 24.2578 238.361V255.615C24.2578 288.28 48.1098 314.765 77.5298 314.765",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5298 179.211C48.1098 179.211 24.2578 205.695 24.2578 238.361V255.615C24.2578 288.28 48.1098 314.765 77.5298 314.765",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M255.752 180.029V148.723H315.701V180.029C315.701 180.029 305.206 193.689 285.725 193.689C266.571 193.689 255.752 180.029 255.752 180.029Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.697 148.342H250.756V159.748H320.697V148.342Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.98 178.202V161.568H176.449V178.202C176.449 178.202 174.966 183.639 172.214 183.639C169.508 183.639 167.98 178.202 167.98 178.202Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.575 159.442H165.241V161.568H178.575V159.442Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.816 179.264V162.63H148.285V179.264C148.285 179.264 146.802 183.488 144.05 183.488C141.345 183.488 139.816 179.264 139.816 179.264Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.411 160.505H137.077V162.63H150.411V160.505Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.881 179.264V162.63H119.35V179.264C119.35 179.264 117.867 182.881 115.115 182.881C112.409 182.882 110.881 179.264 110.881 179.264Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.475 160.505H108.141V162.63H121.475V160.505Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4902 179.264V162.63H91.9592V179.264C91.9592 179.264 90.4762 183.488 87.7242 183.488C85.0182 183.488 83.4902 179.264 83.4902 179.264Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.084 160.505H80.75V162.63H94.084V160.505Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.304 314.764C350.723 314.764 374.576 288.28 374.576 255.614V238.36C374.576 205.695 350.724 179.21 321.304 179.21",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.304 314.764C350.723 314.764 374.576 288.28 374.576 255.614V238.36C374.576 205.695 350.724 179.21 321.304 179.21",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M429.926 390.333C424.615 388.216 420.822 385.884 418.23 383.269C416.205 381.228 415.076 377.948 415.076 377.948L414.743 390.865C414.743 390.865 414.743 392.504 428.941 400.093C432.365 401.923 439.602 404.218 443.303 405.391C446.934 406.543 454.446 407.932 458.171 408.735C462.663 409.701 471.656 411.601 476.175 412.434C481.319 413.382 496.809 415.266 496.809 415.266L518.251 417.076C518.251 417.076 535.452 418.682 541.183 419.057C546.953 419.434 558.491 420.279 564.27 420.448C570.538 420.631 583.082 421.021 589.353 421.055C596.459 421.093 610.669 421.889 617.774 421.839C624.425 421.792 637.723 422.038 644.372 421.839C650.841 421.645 669.635 421.485 669.635 421.485V409.39C669.635 409.39 659.251 410.096 643.138 410.245C633.441 410.335 621.89 409.837 609.763 409.954C592.943 410.115 575.015 409.157 559.395 408.489C546.499 407.939 535.176 407.781 527.347 406.914C521.338 406.247 507.608 404.752 495.297 403.483C481.55 402.066 479.751 402.088 467.8 399.314C461.265 397.796 454.95 396.926 448.606 395.454C448.606 395.454 434.423 392.127 429.926 390.333Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.293 381.257H600.501V431.828H605.293V381.257Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.063 381.257H633.271V431.828H638.063V381.257Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.981 389.898H589.106V405.979H648.981V389.898Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.989 429.751H598.893V435.213H606.989V429.751Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.934 381.326H599.864V377.684H601.727V376.429H604.113V377.664H605.935L605.934 381.326Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.601 397.938C608.601 401.089 606.047 403.642 602.898 403.642C599.748 403.642 597.194 401.089 597.194 397.938C597.194 394.79 599.748 392.236 602.898 392.236C606.047 392.235 608.601 394.788 608.601 397.938Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.877 397.937C606.877 400.133 605.096 401.915 602.9 401.915C600.704 401.915 598.923 400.133 598.923 397.937C598.923 395.743 600.704 393.96 602.9 393.96C605.096 393.96 606.877 395.741 606.877 397.937Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.911 397.947L604.732 399.149L602.911 397.947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.911 397.947L604.732 399.149",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.246 397.927C603.246 398.106 603.101 398.25 602.922 398.25C602.743 398.25 602.597 398.106 602.597 397.927C602.597 397.748 602.743 397.602 602.922 397.602C603.101 397.602 603.246 397.747 603.246 397.927Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.925 401.346L601.686 400.055L600.925 401.346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.925 401.346L601.686 400.055",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.422 399.911L600.659 399.174L599.422 399.911Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.422 399.911L600.659 399.174",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.967 397.9H600.374H598.967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.967 397.9H600.374",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.53 395.941L600.741 396.622L599.53 395.941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.53 395.941L600.741 396.622",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.977 394.561L601.696 395.731L600.977 394.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.977 394.561L601.696 395.731",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.923 394.012V395.419V394.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.923 394.012V395.419",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.867 394.561L604.167 395.756L604.867 394.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.867 394.561L604.167 395.756",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.302 395.995L605.108 396.641L606.302 395.995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.302 395.995L605.108 396.641",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.811 397.859H605.431H606.811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.811 397.859H605.431",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.382 399.883L605.08 399.115L606.382 399.883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.382 399.883L605.08 399.115",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.881 401.32L604.155 400.099L604.881 401.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.881 401.32L604.155 400.099",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.873 397.94C606.873 400.136 605.091 401.918 602.895 401.918C600.699 401.918 598.918 400.136 598.918 397.94C598.918 395.745 600.699 393.963 602.895 393.963C605.09 393.963 606.873 395.744 606.873 397.94Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.202 208.475C825.202 218.844 795.184 228.085 748.355 234.077L825.202 208.475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.202 208.475C825.202 218.844 795.184 228.085 748.355 234.077",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.575 236.635C653.572 237.284 636.816 237.628 619.557 237.628C507.051 237.628 415.849 222.985 415.849 204.922",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.575 236.635C653.572 237.284 636.816 237.628 619.557 237.628C507.051 237.628 415.849 222.985 415.849 204.922",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.472 330.123C653.469 330.77 636.713 331.116 619.454 331.116C506.948 331.116 415.746 316.473 415.746 298.41",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.472 330.123C653.469 330.77 636.713 331.116 619.454 331.116C506.948 331.116 415.746 316.473 415.746 298.41",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.894 301.963C824.894 312.332 795.007 321.573 748.381 327.565L824.894 301.963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.894 301.963C824.894 312.332 795.007 321.573 748.381 327.565",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.038 211.119C429.053 211.622 428.658 212.038 428.156 212.049C427.654 212.06 427.234 211.661 427.218 211.158C427.204 210.656 427.598 210.239 428.1 210.229C428.603 210.218 429.023 210.616 429.038 211.119Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.509 204.903C418.523 205.406 418.129 205.822 417.627 205.833C417.125 205.844 416.704 205.445 416.69 204.942C416.675 204.44 417.07 204.023 417.572 204.013C418.075 204.002 418.494 204.4 418.509 204.903Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.468 232.936C644.482 233.439 644.088 233.855 643.585 233.866C643.083 233.877 642.663 233.478 642.648 232.975C642.634 232.473 643.028 232.056 643.53 232.046C644.033 232.035 644.453 232.433 644.468 232.936Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.957 232.936C616.971 233.439 616.577 233.855 616.074 233.866C615.572 233.877 615.152 233.478 615.137 232.975C615.122 232.473 615.517 232.056 616.019 232.046C616.522 232.035 616.942 232.433 616.957 232.936Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.446 232.329C589.461 232.832 589.067 233.248 588.564 233.259C588.061 233.27 587.642 232.871 587.626 232.368C587.611 231.866 588.006 231.449 588.508 231.439C589.013 231.428 589.433 231.827 589.446 232.329Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.364 231.732C564.378 232.235 563.984 232.651 563.481 232.662C562.979 232.673 562.559 232.274 562.544 231.771C562.529 231.269 562.924 230.852 563.426 230.842C563.929 230.831 564.349 231.229 564.364 231.732Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.367 230.215C540.381 230.718 539.987 231.134 539.485 231.145C538.982 231.156 538.563 230.757 538.548 230.254C538.533 229.752 538.927 229.335 539.43 229.325C539.932 229.314 540.352 229.712 540.367 230.215Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.435 228.294C517.449 228.797 517.055 229.213 516.552 229.224C516.05 229.235 515.63 228.836 515.615 228.333C515.6 227.831 515.995 227.414 516.497 227.404C517 227.392 517.42 227.79 517.435 228.294Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.993 226.17C496.007 226.673 495.613 227.089 495.11 227.1C494.608 227.111 494.188 226.712 494.173 226.209C494.158 225.707 494.553 225.29 495.055 225.28C495.557 225.268 495.977 225.667 495.993 226.17Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.36 222.773C475.374 223.276 474.98 223.692 474.477 223.703C473.975 223.714 473.555 223.315 473.54 222.812C473.525 222.309 473.92 221.893 474.422 221.883C474.925 221.872 475.345 222.271 475.36 222.773Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.356 219.918C457.371 220.421 456.977 220.837 456.474 220.848C455.972 220.859 455.552 220.46 455.536 219.957C455.521 219.455 455.916 219.038 456.418 219.028C456.922 219.017 457.342 219.415 457.356 219.918Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.489 215.872C442.504 216.375 442.109 216.791 441.607 216.802C441.105 216.813 440.685 216.414 440.669 215.911C440.654 215.409 441.049 214.992 441.551 214.982C442.055 214.971 442.474 215.37 442.489 215.872Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.036 222.414C429.05 222.917 428.656 223.333 428.154 223.344C427.652 223.355 427.231 222.956 427.216 222.453C427.201 221.95 427.596 221.534 428.098 221.524C428.601 221.513 429.021 221.911 429.036 222.414Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.507 216.199C418.521 216.702 418.127 217.118 417.625 217.129C417.123 217.14 416.702 216.741 416.687 216.238C416.672 215.735 417.067 215.319 417.569 215.309C418.073 215.297 418.493 215.696 418.507 216.199Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.466 244.231C644.479 244.734 644.086 245.15 643.583 245.161C643.08 245.172 642.66 244.773 642.646 244.27C642.632 243.768 643.026 243.351 643.528 243.341C644.031 243.33 644.451 243.729 644.466 244.231Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.955 244.231C616.968 244.734 616.575 245.15 616.072 245.161C615.569 245.172 615.149 244.773 615.135 244.27C615.12 243.768 615.515 243.351 616.017 243.341C616.52 243.33 616.94 243.729 616.955 244.231Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.445 243.624C589.46 244.127 589.066 244.543 588.563 244.554C588.06 244.565 587.64 244.166 587.625 243.663C587.61 243.161 588.005 242.744 588.507 242.734C589.011 242.723 589.431 243.122 589.445 243.624Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.363 243.027C564.376 243.53 563.983 243.946 563.48 243.957C562.977 243.968 562.557 243.569 562.543 243.066C562.528 242.564 562.923 242.147 563.425 242.137C563.928 242.126 564.347 242.525 564.363 243.027Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.365 241.51C540.379 242.013 539.985 242.429 539.483 242.44C538.981 242.451 538.561 242.052 538.546 241.549C538.531 241.047 538.925 240.63 539.428 240.62C539.93 240.609 540.35 241.008 540.365 241.51Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.433 239.589C517.446 240.092 517.053 240.508 516.55 240.519C516.047 240.53 515.627 240.131 515.613 239.628C515.598 239.126 515.993 238.709 516.495 238.699C516.998 238.688 517.418 239.086 517.433 239.589Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.991 237.465C496.004 237.968 495.611 238.384 495.108 238.395C494.606 238.406 494.185 238.007 494.171 237.504C494.156 237.002 494.551 236.585 495.053 236.575C495.556 236.564 495.976 236.962 495.991 237.465Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.358 234.068C475.371 234.571 474.978 234.987 474.475 234.998C473.973 235.009 473.552 234.61 473.538 234.107C473.523 233.605 473.918 233.188 474.42 233.178C474.923 233.167 475.343 233.566 475.358 234.068Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.354 231.214C457.369 231.717 456.975 232.133 456.472 232.144C455.97 232.155 455.549 231.756 455.534 231.253C455.519 230.751 455.914 230.334 456.416 230.324C456.92 230.313 457.34 230.711 457.354 231.214Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.487 227.168C442.501 227.671 442.107 228.087 441.605 228.098C441.103 228.109 440.682 227.71 440.667 227.207C440.652 226.705 441.047 226.288 441.549 226.278C442.053 226.267 442.473 226.665 442.487 227.168Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.858 316.112C430.873 316.614 430.478 317.032 429.976 317.042C429.474 317.053 429.054 316.654 429.038 316.151C429.024 315.649 429.418 315.232 429.92 315.222C430.424 315.212 430.844 315.61 430.858 316.112Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.33 309.897C420.344 310.399 419.95 310.816 419.448 310.826C418.946 310.837 418.525 310.438 418.51 309.936C418.495 309.434 418.891 309.017 419.392 309.007C419.896 308.996 420.315 309.395 420.33 309.897Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.288 337.93C646.302 338.433 645.908 338.851 645.405 338.86C644.902 338.871 644.483 338.471 644.468 337.969C644.454 337.467 644.848 337.05 645.35 337.04C645.853 337.029 646.273 337.426 646.288 337.93Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.778 337.93C618.792 338.433 618.398 338.851 617.895 338.86C617.392 338.871 616.973 338.471 616.958 337.969C616.943 337.467 617.338 337.05 617.84 337.04C618.343 337.029 618.763 337.426 618.778 337.93Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.267 337.323C591.282 337.826 590.888 338.244 590.385 338.253C589.883 338.264 589.463 337.864 589.447 337.362C589.431 336.86 589.827 336.443 590.329 336.433C590.833 336.422 591.253 336.82 591.267 337.323Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.185 336.726C566.199 337.229 565.804 337.645 565.302 337.656C564.8 337.667 564.38 337.267 564.365 336.765C564.35 336.263 564.745 335.846 565.247 335.837C565.75 335.824 566.17 336.223 566.185 336.726Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.187 335.208C542.201 335.711 541.807 336.127 541.305 336.138C540.803 336.148 540.383 335.749 540.368 335.247C540.353 334.745 540.747 334.328 541.25 334.319C541.753 334.307 542.173 334.706 542.187 335.208Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.255 333.287C519.269 333.79 518.874 334.207 518.372 334.217C517.87 334.227 517.45 333.827 517.435 333.325C517.42 332.823 517.815 332.406 518.317 332.397C518.82 332.386 519.24 332.784 519.255 333.287Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.813 331.163C497.827 331.666 497.433 332.083 496.93 332.093C496.427 332.103 496.008 331.703 495.993 331.201C495.978 330.699 496.373 330.282 496.875 330.273C497.378 330.262 497.798 330.66 497.813 331.163Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.18 327.767C477.194 328.269 476.8 328.687 476.297 328.696C475.795 328.708 475.375 328.308 475.36 327.806C475.345 327.304 475.74 326.887 476.242 326.877C476.744 326.867 477.165 327.264 477.18 327.767Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.177 324.912C459.192 325.414 458.798 325.832 458.295 325.841C457.793 325.853 457.373 325.453 457.357 324.95C457.342 324.448 457.737 324.031 458.239 324.021C458.743 324.011 459.163 324.409 459.177 324.912Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.31 320.866C444.325 321.368 443.93 321.785 443.428 321.795C442.926 321.806 442.506 321.407 442.49 320.904C442.475 320.402 442.87 319.985 443.372 319.975C443.875 319.965 444.295 320.363 444.31 320.866Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.858 302.39C430.873 302.893 430.478 303.309 429.976 303.32C429.474 303.331 429.054 302.932 429.038 302.429C429.024 301.927 429.418 301.51 429.92 301.5C430.424 301.489 430.844 301.887 430.858 302.39Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.33 296.174C420.344 296.677 419.95 297.093 419.448 297.104C418.946 297.115 418.525 296.716 418.51 296.213C418.495 295.711 418.891 295.294 419.392 295.284C419.896 295.273 420.315 295.671 420.33 296.174Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.288 324.207C646.302 324.71 645.908 325.126 645.405 325.136C644.902 325.148 644.483 324.748 644.468 324.245C644.454 323.743 644.848 323.326 645.35 323.317C645.853 323.306 646.273 323.705 646.288 324.207Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.778 324.207C618.792 324.71 618.398 325.126 617.895 325.136C617.392 325.148 616.973 324.748 616.958 324.245C616.943 323.743 617.338 323.326 617.84 323.317C618.343 323.306 618.763 323.705 618.778 324.207Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.267 323.6C591.282 324.103 590.888 324.519 590.385 324.529C589.883 324.541 589.463 324.141 589.447 323.638C589.432 323.136 589.827 322.719 590.329 322.71C590.833 322.699 591.253 323.098 591.267 323.6Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.185 323.003C566.199 323.506 565.804 323.923 565.302 323.933C564.8 323.944 564.38 323.545 564.365 323.042C564.35 322.54 564.745 322.123 565.247 322.113C565.75 322.102 566.17 322.501 566.185 323.003Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.187 321.486C542.201 321.989 541.807 322.406 541.305 322.416C540.803 322.427 540.383 322.028 540.368 321.525C540.353 321.023 540.747 320.606 541.25 320.596C541.753 320.585 542.173 320.983 542.187 321.486Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.255 319.564C519.269 320.067 518.874 320.483 518.372 320.494C517.87 320.505 517.45 320.105 517.435 319.603C517.42 319.101 517.815 318.684 518.317 318.674C518.819 318.664 519.24 319.062 519.255 319.564Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.813 317.44C497.827 317.943 497.433 318.359 496.93 318.37C496.428 318.38 496.008 317.982 495.993 317.479C495.978 316.977 496.373 316.56 496.875 316.55C497.377 316.54 497.798 316.938 497.813 317.44Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.18 314.044C477.194 314.547 476.8 314.963 476.297 314.974C475.795 314.985 475.375 314.586 475.36 314.083C475.345 313.58 475.74 313.164 476.242 313.154C476.745 313.143 477.165 313.542 477.18 314.044Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.177 311.189C459.192 311.692 458.798 312.108 458.295 312.119C457.793 312.13 457.373 311.731 457.357 311.228C457.342 310.726 457.737 310.309 458.239 310.299C458.743 310.288 459.163 310.687 459.177 311.189Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.31 307.143C444.325 307.646 443.93 308.062 443.428 308.073C442.926 308.084 442.506 307.685 442.49 307.182C442.475 306.68 442.87 306.263 443.372 306.253C443.875 306.242 444.295 306.641 444.31 307.143Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.147 126.335C424.836 124.217 421.043 121.886 418.45 119.271C416.425 117.229 415.296 113.951 415.296 113.951L414.963 126.867C414.963 126.867 414.963 128.507 429.162 136.095C432.586 137.925 439.823 140.22 443.524 141.393C447.155 142.545 454.667 143.934 458.392 144.736C462.884 145.703 471.877 147.603 476.396 148.436C481.54 149.385 497.03 151.268 497.03 151.268L518.472 153.079C518.472 153.079 535.673 154.685 541.404 155.06C547.175 155.436 558.712 156.282 564.491 156.451C570.759 156.634 583.303 157.024 589.574 157.058C596.68 157.096 610.89 157.892 617.995 157.842C624.646 157.795 637.944 158.041 644.593 157.842C651.062 157.648 669.856 157.488 669.856 157.488V145.394C669.856 145.394 659.472 146.1 643.359 146.25C633.662 146.34 622.111 145.842 609.984 145.959C593.164 146.12 575.236 145.162 559.616 144.495C546.72 143.945 535.397 143.787 527.568 142.919C521.559 142.253 507.829 140.757 495.518 139.489C481.77 138.072 479.971 138.095 468.021 135.319C461.486 133.801 455.17 132.932 448.827 131.459C448.827 131.457 434.645 128.128 430.147 126.335Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.946 130.531C429.96 131.034 429.566 131.45 429.064 131.461C428.562 131.472 428.141 131.073 428.126 130.57C428.111 130.068 428.507 129.651 429.008 129.641C429.512 129.63 429.932 130.029 429.946 130.531Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.417 124.315C419.431 124.818 419.037 125.234 418.535 125.245C418.033 125.256 417.612 124.857 417.597 124.354C417.582 123.852 417.978 123.435 418.479 123.425C418.984 123.414 419.403 123.813 419.417 124.315Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.376 152.348C645.389 152.851 644.996 153.267 644.493 153.278C643.99 153.289 643.57 152.89 643.556 152.387C643.542 151.884 643.936 151.468 644.438 151.458C644.941 151.447 645.361 151.845 645.376 152.348Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.866 152.348C617.879 152.851 617.486 153.267 616.983 153.278C616.481 153.289 616.06 152.89 616.046 152.387C616.031 151.885 616.426 151.468 616.928 151.458C617.43 151.447 617.85 151.845 617.866 152.348Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.355 151.741C590.37 152.244 589.976 152.66 589.473 152.671C588.97 152.682 588.55 152.283 588.535 151.78C588.52 151.278 588.915 150.861 589.417 150.851C589.921 150.84 590.341 151.238 590.355 151.741Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.273 151.144C565.286 151.647 564.893 152.063 564.39 152.074C563.888 152.085 563.467 151.686 563.453 151.183C563.438 150.681 563.833 150.264 564.335 150.254C564.838 150.243 565.258 150.642 565.273 151.144Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.275 149.627C541.289 150.13 540.895 150.546 540.393 150.557C539.89 150.568 539.471 150.169 539.456 149.666C539.441 149.164 539.835 148.747 540.338 148.737C540.841 148.726 541.261 149.125 541.275 149.627Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.343 147.705C518.356 148.208 517.963 148.624 517.46 148.635C516.957 148.646 516.537 148.247 516.523 147.744C516.508 147.242 516.903 146.825 517.405 146.815C517.908 146.804 518.328 147.203 518.343 147.705Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.901 145.581C496.914 146.084 496.521 146.5 496.018 146.511C495.516 146.522 495.095 146.123 495.081 145.62C495.066 145.118 495.461 144.701 495.963 144.691C496.466 144.68 496.886 145.079 496.901 145.581Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.268 142.186C476.281 142.689 475.888 143.105 475.385 143.116C474.883 143.127 474.462 142.728 474.448 142.225C474.433 141.723 474.828 141.306 475.33 141.296C475.833 141.284 476.253 141.682 476.268 142.186Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.265 139.33C458.28 139.833 457.886 140.249 457.383 140.26C456.881 140.271 456.46 139.872 456.445 139.369C456.43 138.867 456.825 138.45 457.327 138.44C457.831 138.429 458.251 138.828 458.265 139.33Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.397 135.284C443.411 135.787 443.017 136.203 442.515 136.214C442.013 136.225 441.592 135.826 441.577 135.323C441.562 134.821 441.957 134.404 442.459 134.394C442.963 134.383 443.383 134.782 443.397 135.284Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.56 151.547C749.56 151.547 763.984 148.791 768.576 147.812C773.747 146.711 784.095 144.52 789.216 143.204C793.387 142.132 801.758 140.007 805.768 138.44C809.7 136.904 817.595 133.6 820.939 131.023C822.105 130.124 825.513 126.674 825.513 126.674L825.617 114.972C825.617 114.972 822.395 119.607 820.938 120.767C817.439 123.555 809.103 127.207 804.856 128.613C801.018 129.883 793.172 131.897 789.214 132.722C784.085 133.791 773.756 135.591 768.575 136.367C763.984 137.055 749.559 138.218 749.559 138.218L749.56 151.547Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.78 142.186C769.793 142.689 769.4 143.105 768.897 143.116C768.394 143.127 767.975 142.728 767.96 142.225C767.946 141.723 768.34 141.306 768.842 141.296C769.345 141.284 769.765 141.682 769.78 142.186Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.144 126.565C822.157 127.068 821.764 127.484 821.261 127.495C820.758 127.506 820.339 127.107 820.324 126.604C820.309 126.102 820.704 125.685 821.206 125.675C821.708 125.664 822.128 126.062 822.144 126.565Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.973 133.847C806.986 134.35 806.593 134.766 806.09 134.777C805.587 134.788 805.168 134.389 805.153 133.886C805.138 133.384 805.533 132.967 806.035 132.957C806.537 132.946 806.957 133.344 806.973 133.847Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.42 138.331C790.434 138.834 790.04 139.25 789.537 139.261C789.034 139.272 788.615 138.873 788.6 138.37C788.586 137.868 788.98 137.451 789.482 137.441C789.985 137.431 790.404 137.829 790.42 138.331Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.691 330.409C770.704 330.912 770.311 331.328 769.808 331.339C769.306 331.35 768.886 330.95 768.871 330.448C768.857 329.946 769.251 329.529 769.753 329.519C770.255 329.508 770.675 329.906 770.691 330.409Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.054 314.788C823.067 315.291 822.674 315.707 822.171 315.718C821.668 315.729 821.249 315.33 821.234 314.827C821.219 314.325 821.614 313.908 822.116 313.898C822.619 313.887 823.039 314.286 823.054 314.788Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.883 322.07C807.896 322.573 807.503 322.99 807 323C806.498 323.011 806.078 322.612 806.063 322.109C806.048 321.607 806.443 321.19 806.945 321.18C807.448 321.169 807.868 321.568 807.883 322.07Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.33 326.555C791.344 327.057 790.95 327.474 790.447 327.484C789.945 327.496 789.525 327.096 789.51 326.593C789.496 326.091 789.89 325.674 790.392 325.664C790.895 325.654 791.314 326.052 791.33 326.555Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.691 316.472C770.704 316.975 770.311 317.391 769.808 317.402C769.306 317.413 768.886 317.014 768.871 316.511C768.857 316.009 769.251 315.592 769.753 315.582C770.255 315.57 770.675 315.969 770.691 316.472Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.054 300.851C823.067 301.354 822.674 301.77 822.171 301.781C821.668 301.792 821.249 301.393 821.234 300.89C821.219 300.388 821.614 299.971 822.116 299.961C822.619 299.95 823.039 300.348 823.054 300.851Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.883 308.133C807.896 308.636 807.503 309.052 807 309.063C806.498 309.074 806.078 308.675 806.063 308.172C806.048 307.67 806.443 307.253 806.945 307.243C807.448 307.232 807.868 307.63 807.883 308.133Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.33 312.618C791.344 313.121 790.95 313.537 790.447 313.548C789.945 313.559 789.525 313.16 789.51 312.657C789.496 312.155 789.89 311.738 790.392 311.728C790.895 311.717 791.314 312.115 791.33 312.618Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.691 236.104C770.705 236.607 770.311 237.023 769.808 237.034C769.306 237.045 768.886 236.646 768.871 236.143C768.857 235.641 769.251 235.224 769.753 235.214C770.256 235.202 770.676 235.601 770.691 236.104Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.055 220.483C823.068 220.986 822.675 221.402 822.172 221.413C821.67 221.424 821.249 221.025 821.235 220.522C821.221 220.02 821.615 219.603 822.117 219.593C822.619 219.582 823.039 219.98 823.055 220.483Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.883 227.765C807.896 228.268 807.503 228.684 807 228.695C806.498 228.706 806.077 228.307 806.063 227.804C806.049 227.302 806.443 226.885 806.945 226.875C807.448 226.864 807.868 227.263 807.883 227.765Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.331 232.25C791.345 232.753 790.951 233.169 790.448 233.18C789.946 233.191 789.526 232.792 789.511 232.289C789.497 231.787 789.891 231.37 790.393 231.36C790.895 231.349 791.315 231.747 791.331 232.25Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.78 224.18C769.793 224.683 769.4 225.099 768.897 225.11C768.394 225.121 767.975 224.722 767.96 224.219C767.946 223.717 768.34 223.3 768.842 223.29C769.345 223.279 769.765 223.677 769.78 224.18Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.144 208.56C822.157 209.063 821.764 209.479 821.261 209.49C820.758 209.501 820.339 209.102 820.324 208.599C820.309 208.096 820.704 207.68 821.206 207.67C821.708 207.658 822.128 208.057 822.144 208.56Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.973 215.842C806.986 216.345 806.593 216.761 806.09 216.772C805.587 216.783 805.168 216.384 805.153 215.881C805.138 215.378 805.533 214.962 806.035 214.952C806.537 214.941 806.957 215.339 806.973 215.842Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.42 220.326C790.434 220.829 790.04 221.245 789.537 221.256C789.034 221.267 788.615 220.868 788.6 220.365C788.586 219.863 788.98 219.446 789.482 219.436C789.985 219.425 790.404 219.824 790.42 220.326Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.624 100.238L454.927 92.5791L439.152 92.7391C439.152 92.7391 433.893 92.3791 424.79 92.7391C421.508 92.8691 414.262 92.0451 409.619 93.5121C405.11 94.9361 402.185 96.1411 400.314 102.008V111.717C399.909 342.52 400.516 325.529 400.516 325.529H408.202C408.202 325.529 407.721 109.128 408.311 106.611C408.735 104.803 406.39 100.461 415.17 100.344L454.624 100.238Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.366 324.873H396.757V327.3H411.366V324.873Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.215 110.481H409.741C409.741 110.481 408.996 103.252 410.55 101.699C411.903 100.346 417.6 101.075 417.6 101.075V91.9721C417.6 91.9721 405.931 91.1121 402.643 94.3991C399.049 97.9931 400.215 110.481 400.215 110.481Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.294 110.481H459.768C459.768 110.481 460.513 103.252 458.959 101.699C457.606 100.346 451.91 101.075 451.91 101.075V91.9721C451.91 91.9721 463.579 91.1121 466.866 94.3991C470.461 97.9931 469.294 110.481 469.294 110.481Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.356 415.794C749.356 415.794 763.78 413.038 768.372 412.06C773.543 410.959 783.891 408.768 789.012 407.452C793.183 406.379 801.554 404.253 805.564 402.687C809.496 401.152 817.391 397.847 820.735 395.269C821.901 394.371 825.309 390.92 825.309 390.92L825.413 379.219C825.413 379.219 822.191 383.855 820.734 385.015C817.235 387.803 808.899 391.454 804.652 392.861C800.814 394.132 792.968 396.145 789.01 396.97C783.881 398.04 773.552 399.84 768.371 400.617C763.78 401.305 749.355 402.468 749.355 402.468V415.794H749.356Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.493 396.444C433.508 396.946 433.113 397.364 432.611 397.373C432.109 397.385 431.689 396.985 431.673 396.482C431.659 395.98 432.053 395.563 432.555 395.553C433.059 395.544 433.478 395.942 433.493 396.444Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.964 390.836C422.978 391.338 422.584 391.755 422.082 391.765C421.58 391.776 421.159 391.377 421.144 390.874C421.129 390.372 421.524 389.955 422.026 389.946C422.53 389.935 422.95 390.333 422.964 390.836Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.923 416.441C648.937 416.943 648.543 417.361 648.04 417.371C647.537 417.382 647.118 416.982 647.103 416.48C647.089 415.978 647.483 415.561 647.985 415.551C648.488 415.541 648.907 415.938 648.923 416.441Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.413 416.441C621.427 416.943 621.033 417.361 620.53 417.371C620.028 417.382 619.608 416.982 619.593 416.48C619.579 415.978 619.973 415.561 620.475 415.551C620.977 415.541 621.397 415.938 621.413 416.441Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.902 415.834C593.917 416.336 593.523 416.754 593.02 416.764C592.518 416.775 592.098 416.375 592.082 415.873C592.067 415.371 592.462 414.954 592.964 414.944C593.468 414.933 593.887 415.331 593.902 415.834Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.82 415.237C568.834 415.74 568.44 416.156 567.937 416.167C567.435 416.177 567.015 415.778 567 415.276C566.986 414.774 567.38 414.357 567.882 414.348C568.385 414.336 568.804 414.735 568.82 415.237Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.822 414.327C544.837 414.83 544.442 415.246 543.94 415.257C543.437 415.267 543.018 414.868 543.003 414.366C542.988 413.864 543.382 413.447 543.885 413.438C544.388 413.426 544.806 413.824 544.822 414.327Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.89 412.405C521.904 412.908 521.51 413.325 521.007 413.335C520.505 413.345 520.085 412.945 520.07 412.443C520.056 411.941 520.45 411.524 520.952 411.515C521.455 411.504 521.874 411.903 521.89 412.405Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.448 410.281C500.462 410.784 500.068 411.201 499.565 411.211C499.063 411.221 498.643 410.821 498.628 410.319C498.614 409.817 499.008 409.4 499.51 409.391C500.013 409.381 500.432 409.779 500.448 410.281Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.815 407.492C479.829 407.994 479.435 408.411 478.932 408.42C478.43 408.432 478.01 408.032 477.995 407.53C477.981 407.028 478.375 406.611 478.877 406.601C479.379 406.591 479.8 406.99 479.815 407.492Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.812 404.03C461.827 404.532 461.433 404.95 460.93 404.959C460.428 404.971 460.008 404.571 459.992 404.068C459.977 403.566 460.372 403.149 460.874 403.139C461.378 403.129 461.797 403.527 461.812 404.03Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.944 400.591C446.959 401.093 446.564 401.51 446.062 401.52C445.56 401.531 445.14 401.132 445.124 400.629C445.11 400.127 445.505 399.71 446.006 399.7C446.51 399.69 446.929 400.089 446.944 400.591Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.601 405.915C771.614 406.418 771.221 406.836 770.718 406.845C770.216 406.855 769.796 406.456 769.781 405.954C769.767 405.452 770.161 405.035 770.663 405.025C771.166 405.016 771.586 405.413 771.601 405.915Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.151 401.819C793.165 402.322 792.771 402.74 792.268 402.749C791.766 402.759 791.346 402.36 791.331 401.858C791.317 401.356 791.711 400.939 792.213 400.929C792.716 400.919 793.135 401.317 793.151 401.819Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.793 396.577C808.806 397.08 808.413 397.497 807.91 397.507C807.408 397.517 806.988 397.117 806.973 396.615C806.958 396.113 807.353 395.696 807.855 395.687C808.358 395.676 808.778 396.074 808.793 396.577Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.054 389.531C823.067 390.034 822.674 390.452 822.171 390.461C821.668 390.471 821.249 390.072 821.234 389.57C821.219 389.068 821.614 388.651 822.116 388.641C822.618 388.631 823.039 389.028 823.054 389.531Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.15 110.543H457.542V113.577H472.15V110.543Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.538 366.58C404.538 366.58 405.381 365.812 405.731 365.684C405.904 365.621 406.288 365.655 406.471 365.685C406.623 365.712 407.052 365.884 407.052 365.884L407.05 367.491L407.632 367.492L407.639 363.151V363.028L407.645 358.687L407.063 358.686L407.061 360.294C407.061 360.294 406.631 360.466 406.479 360.491C406.296 360.521 405.906 360.571 405.739 360.49C405.381 360.317 404.689 359.301 404.689 359.301C404.689 359.301 405.197 362.131 405.173 363.085C405.146 363.975 404.538 366.58 404.538 366.58Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.636 362.965H405.62V363.393H407.636V362.965Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.639 360.781H405.623V361.388H407.639V360.781Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.639 360.781H405.623V361.995H407.639V360.781Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.632 364.767H405.617V365.981H407.632V364.767Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.981 357.009L402.964 369.146L406.412 369.151L406.429 357.014L402.981 357.009Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.001 355.986L402.98 370.55L403.587 370.551L403.608 355.987L403.001 355.986Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.982 368.051L401.522 367.627L401.534 358.459L402.996 358.12",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.982 368.051L401.522 367.627L401.534 358.459L402.996 358.12",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.03 366.098C405.569 366.098 406.005 365.661 406.005 365.123C406.005 364.584 405.569 364.148 405.03 364.148C404.492 364.148 404.055 364.584 404.055 365.123C404.055 365.661 404.492 366.098 405.03 366.098Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.036 361.823C405.575 361.823 406.011 361.387 406.011 360.848C406.011 360.31 405.575 359.873 405.036 359.873C404.498 359.873 404.061 360.31 404.061 360.848C404.061 361.387 404.498 361.823 405.036 361.823Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.372 354.192H404.583V372.397H411.372V354.192Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.791 374.701H412.81",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.888 353.369H410.013V354.788H410.888V353.369Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.888 354.79H410.013V355.94H410.888V354.79Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.888 352.796H410.013V353.369H410.888V352.796Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.888 352.796H410.013V355.939H410.888V352.796Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.433 353.9H410.889V354.832H411.433V353.9Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.888 362.45H410.013V363.87H410.888V362.45Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.888 363.87H410.013V365.021H410.888V363.87Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.888 361.876H410.013V362.448H410.888V361.876Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.888 361.876H410.013V365.019H410.888V361.876Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.433 362.981H410.889V363.913H411.433V362.981Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.888 371.537H410.013V372.956H410.888V371.537Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.888 372.957H410.013V374.106H410.888V372.957Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.888 370.963H410.013V371.537H410.888V370.963Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.888 370.963H410.013V374.105H410.888V370.963Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.433 372.068H410.889V372.999H411.433V372.068Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.974 351.158H411.153V375.431H412.974V351.158Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.581 351.158H413.154V375.431H415.581V351.158Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.957 114.55H456.431C456.431 114.55 457.176 107.321 455.622 105.768C454.269 104.415 448.573 105.144 448.573 105.144V96.0409C448.573 96.0409 460.242 95.1809 463.529 98.4679C467.123 102.062 465.957 114.55 465.957 114.55Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.997 114.883H453.389V117.917H467.997V114.883Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.436 103.093L449.739 95.4341L433.964 95.5941C433.964 95.5941 428.705 95.2341 419.602 95.5941C416.321 95.7241 409.073 94.9001 404.431 96.3671C399.922 97.7911 396.997 98.9961 395.126 104.863V114.572C394.721 345.375 395.328 328.383 395.328 328.383H403.014C403.014 328.383 402.533 111.982 403.123 109.465C403.547 107.657 401.202 103.315 409.982 103.198L449.436 103.093Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.264 113.336H403.789C403.789 113.336 403.045 106.107 404.598 104.554C405.951 103.201 411.648 103.93 411.648 103.93V94.8271C411.648 94.8271 399.979 93.9671 396.692 97.2541C393.097 100.849 394.264 113.336 394.264 113.336Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.731 327.483H392.123V329.91H406.731V327.483Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.37 397.938C641.37 401.089 638.816 403.642 635.667 403.642C632.518 403.642 629.963 401.089 629.963 397.938C629.963 394.79 632.517 392.236 635.667 392.236C638.816 392.235 641.37 394.788 641.37 397.938Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.646 397.945C639.646 400.141 637.865 401.923 635.669 401.923C633.473 401.923 631.692 400.141 631.692 397.945C631.692 395.751 633.473 393.968 635.669 393.968C637.865 393.968 639.646 395.75 639.646 397.945Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.681 397.955L637.501 399.157L635.681 397.955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.681 397.955L637.501 399.157",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.016 397.935C636.016 398.114 635.871 398.258 635.692 398.258C635.513 398.258 635.367 398.114 635.367 397.935C635.367 397.756 635.513 397.61 635.692 397.61C635.871 397.61 636.016 397.756 636.016 397.935Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.694 401.354L634.455 400.063L633.694 401.354Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.694 401.354L634.455 400.063",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.192 399.919L633.429 399.182L632.192 399.919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.192 399.919L633.429 399.182",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.736 397.908H633.143H631.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.736 397.908H633.143",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.3 395.95L633.511 396.631L632.3 395.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.3 395.95L633.511 396.631",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.747 394.569L634.466 395.739L633.747 394.569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.747 394.569L634.466 395.739",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.693 394.02V395.427V394.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.693 394.02V395.427",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.637 394.569L636.937 395.764L637.637 394.569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.637 394.569L636.937 395.764",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.071 396.003L637.877 396.649L639.071 396.003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.071 396.003L637.877 396.649",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.581 397.867H638.201H639.581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.581 397.867H638.201",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.152 399.892L637.85 399.124L639.152 399.892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.152 399.892L637.85 399.124",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.651 401.328L636.925 400.107L637.651 401.328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.651 401.328L636.925 400.107",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.642 397.948C639.642 400.144 637.86 401.926 635.664 401.926C633.468 401.926 631.687 400.144 631.687 397.948C631.687 395.753 633.468 393.971 635.664 393.971C637.86 393.971 639.642 395.752 639.642 397.948Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.712 374.982H602.615V375.659H603.712V374.982Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.615 374.982H601.727V375.659H602.615V374.982Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.155 374.982H603.712V375.659H604.155V374.982Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.154 374.982H601.727V375.659H604.154V374.982Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.302 375.659H602.582V376.079H603.302V375.659Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.139 376.15L600.503 376.086L599.234 374.239",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.139 376.15L600.503 376.086L599.234 374.239",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.234 373.769H581.448V374.983H599.234V373.769Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.703 381.326H632.633V377.684H634.496V376.429H636.882V377.664H638.704L638.703 381.326Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.006 375.005H634.909V375.682H636.006V375.005Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.893 375.005H636.005V375.682H636.893V375.005Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.909 375.005H634.466V375.682H634.909V375.005Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.893 375.005H634.466V375.682H636.893V375.005Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.039 375.682H635.319V376.102H636.039V375.682Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.387 374.262L638.118 376.11L634.481 376.173",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.387 374.262L638.118 376.11L634.481 376.173",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.173 373.792H639.387V375.006H657.173V373.792Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.933 429.097H632.077V434.559H639.933V429.097Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_211_35062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 790,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacility);
export default __webpack_public_path__ + "static/media/facility.c28d6f52bc04f1be81b47b65eb8489ba.svg";
export { ForwardRef as ReactComponent };